var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreensLow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-screen-low{fill:#7eac20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-low",
    d: "M80.73,98.73H49.27a5.15,5.15,0,0,1-5.14-5.14V36.41a5.15,5.15,0,0,1,5.14-5.14H80.73a5.15,5.15,0,0,1,5.14,5.14V93.59A5.15,5.15,0,0,1,80.73,98.73ZM49.27,34.27a2.14,2.14,0,0,0-2.14,2.14V93.59a2.14,2.14,0,0,0,2.14,2.14H80.73a2.14,2.14,0,0,0,2.14-2.14V36.41a2.14,2.14,0,0,0-2.14-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-low",
    d: "M84.37,42.21H45.63a.93.93,0,0,1,0-1.86H84.37a.93.93,0,1,1,0,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-low",
    d: "M84.37,42.83H45.63a1.56,1.56,0,0,1,0-3.11H84.37a1.56,1.56,0,0,1,0,3.11ZM45.63,41a.3.3,0,0,0-.3.31.29.29,0,0,0,.3.3H84.37a.29.29,0,0,0,.3-.3.3.3,0,0,0-.3-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-low",
    d: "M84.37,90.5H45.63a.93.93,0,1,1,0-1.86H84.37a.93.93,0,0,1,0,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-low",
    d: "M84.37,91.13H45.63a1.56,1.56,0,0,1,0-3.11H84.37a1.56,1.56,0,0,1,0,3.11ZM45.63,89.27a.31.31,0,0,0,0,.61H84.37a.31.31,0,0,0,0-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-low",
    d: "M69.49,37.8h-9a.93.93,0,0,1,0-1.86h9a.93.93,0,0,1,0,1.86Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensLow);
export default __webpack_public_path__ + "static/media/screens-low.1ca4894e.svg";
export { ForwardRef as ReactComponent };